import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { useIsNestedLayout } from "@plansoft-configuration-renderer/layout";
import { useConfigurationStatus } from "./useConfigurationStatus";
const configurationStatusFabDefaults = {
    size: "medium",
    variant: "extended",
    fabSxProps: { position: "static" },
    showInSubstructures: false,
};
export function ConfigurationStatusFab(props) {
    const cfgObject = useCsCfgObject();
    const { isComplete, statusTextLong, statusTextShort, StatusIcon } = useConfigurationStatus(cfgObject);
    const isNestedLayout = useIsNestedLayout();
    const { variant = configurationStatusFabDefaults.variant, size = configurationStatusFabDefaults.size, fabSxProps = configurationStatusFabDefaults.fabSxProps, } = props;
    const showText = variant === "extended";
    const iconSxProps = showText ? { mr: 1 } : {};
    if (isNestedLayout && !props.showInSubstructures) {
        return _jsx(Fragment, {});
    }
    return (_jsx(Tooltip, { title: statusTextLong, children: _jsxs(Fab, { variant: variant, size: size, color: isComplete ? "success" : "warning", "aria-label": statusTextShort, sx: fabSxProps, children: [_jsx(StatusIcon, { sx: iconSxProps }), " ", showText && statusTextShort] }) }));
}
//# sourceMappingURL=ConfigurationStatusFab.js.map